'use client'; // Error components must be Client Components

import * as React from 'react';
import { RiAlarmWarningFill } from 'react-icons/ri';

import Button from '@/components/buttons/Button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.error(error);
  }, [error]);

  return (
    <main>
      <section className='relative overflow-hidden bg-primary-800'>
        <div className='layout relative z-10 flex min-h-screen flex-col items-center justify-center gap-11 text-center text-white'>
          <RiAlarmWarningFill
            size={60}
            className='animate-flicker text-white'
          />
          <h1 className='h2'>Oops, something went wrong!</h1>
          <Button variant='outline' onClick={reset} className='mt-4'>
            Try again
          </Button>
        </div>
        <div
          aria-hidden={true}
          className='pointer-events-none absolute -bottom-[250px] -left-[250px] z-0 block h-[600px] w-[600px] rounded-full bg-primary-600 blur-[120px] md:h-[800px] md:w-[800px] md:blur-[200px] lg:h-[1229px] lg:w-[1229px]'
        />
      </section>
    </main>
  );
}
